import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { TemplateComponent } from '../template/template.component';
import { BaseListComponent } from '../base-list/base-list.component';
import { EFilterType, ITableConfig } from '../../../interface/table.config';
import { CrudService } from '../service/crud.service';
import { ICrudRes } from '../../../interface/http.config';
import { NgIf } from '@angular/common';
import { Router } from '@angular/router';
import { CrudListModel } from '../../../model/crud-list.model';
import { listFromMap, valueFromList } from '../../../helper/list.helper';
import { ECrudFilterType } from '../../../interface/crud.filter-type.enum';

@Component({
  selector: 'app-form',
  standalone: true,
  imports: [TemplateComponent, BaseListComponent, NgIf],
  templateUrl: './form.component.html',
  styleUrl: './form.component.scss',
})
export class FormComponent extends CrudListModel implements OnInit {
  override editLink = '/dashboard/form-edit/';
  override addLink = '/dashboard/form-create';

  clientList: Record<string, string> = {};
  clientListMap: { value: string; label: string }[] = [];

  constructor(
    crudService: CrudService,
    protected cdr: ChangeDetectorRef,
    router: Router,
  ) {
    super(crudService, router);

    this.crudService.setProvider('form');
    // this.crudService.orderBy = 'createdAt';
  }

  protected tableConfig: ITableConfig = {
    cells: [
      {
        header: 'id',
        field: 'id',
        sortable: true,
        filterType: EFilterType.TEXT,
        crudFilterType: ECrudFilterType.EXACT,
      },
      {
        header: 'Date',
        field: 'date',
        sortable: true,
        filterType: EFilterType.TEXT,
        crudFilterType: ECrudFilterType.EXACT,
      },
      {
        header: 'Name',
        field: 'name',
        sortable: true,
        filterType: EFilterType.TEXT,
        crudFilterType: ECrudFilterType.EXACT,
      },
      {
        header: 'Phone',
        field: 'phone',
        sortable: true,
        filterType: EFilterType.TEXT,
        crudFilterType: ECrudFilterType.EXACT,
      },
      {
        header: 'Email',
        field: 'email',
        sortable: true,
        filterType: EFilterType.TEXT,
        crudFilterType: ECrudFilterType.EXACT,
      },
      {
        header: 'Messenger',
        field: 'messenger',
        sortable: true,
        filterType: EFilterType.TEXT,
        crudFilterType: ECrudFilterType.EXACT,
      },
      {
        header: 'Request',
        field: 'request',
        sortable: true,
        filterType: EFilterType.TEXT,
        crudFilterType: ECrudFilterType.EXACT,
      },
    ],
    actions: ['edit', 'delete'],
  };

  ngOnInit() {
    this.update();

    this.crudService.getList('client', 'id', 'email').then((data) => {
      this.clientList = data;
      this.clientListMap = listFromMap(data);

      this.cdr.detectChanges();
    });
  }
}
